export default {
  title: {
    en: 'Gift subscription',
  },
  text: {
    en: `
    {giverName} sent you a {monthsCount, plural, one {month} other {#-months}} gift subscription. 
    {monthsCount, plural, one {month} other {# months}} of subscription were added to your account.
  `,
  },
}
